import React, { useState, useEffect } from 'react';
import Strapi from '../../services/strapi';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import qs from 'qs';

export interface AuthorsProps {
	onChange?: (newValue: any) => void,
    value?: any,
    variant?: "outlined" | "filled" | "standard",
    single?: boolean
}

const AuthorsSearch = (props: AuthorsProps) => {
	const [options, setOptions] = useState<any[]>([]);
	const [inputValue, setInputValue] = useState<string>("");

	useEffect(() => {
		const current_input = inputValue;

		Strapi.get(`authors/search?${qs.stringify({
			string: inputValue,
			_limit: 10,
		})}`).then((r) => {
			if (current_input === inputValue) {
				setOptions(() => r);
			}
		});
	}, [inputValue])

	return <Autocomplete
        multiple={!props.single}
        value={props.value}
        options={options}
        onInputChange={(_, newValue) => {
            setInputValue(newValue);
        }}
        renderInput={(params) => (
            <TextField {...params} fullWidth variant={props.variant} label="Auteur"/>
        )}
        renderOption={(option) => (
            <div>
                <strong>{option.firstname + " " + option.lastname}</strong>
                <div dangerouslySetInnerHTML={{
                    __html: option.shortbiography ?? option.longbiography
                }}/>
            </div>
        )}
        getOptionLabel={(option) => (option.firstname + " " + option.lastname)}
        onChange={(e, changedValue) => {
            if (props.onChange) {
                props.onChange(changedValue);
            }
        }}
    />
}

export default AuthorsSearch;